<script>
import { mapState, mapActions } from "vuex";
import styles from "../subMenu/subMenu.module.scss";
import { animate } from "../common/js/animate";
import classnames from "classnames";
export default {
  name: "submenu",
  data() {
    return {
      menu: [],
      arrowStatus: true,
      fade: "fade",
      // highlightTop: 0, // 移除响应式top
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.menu.subMenuList,
      currentSubMenu: (state) => state.menu.currentSubMenu,
      currentMovePlace: (state) => state.menu.currentMovePlace,
    }),
  },
  mounted() {
    this.list.map((item) => {
      if (item.show) {
        const childrenMenu = item.children;
        this.$nextTick(function() {
          this.initMovePlace(childrenMenu);
        });
      }
    });
  },
  methods: {
    ...mapActions("menu", [
      "setSubmenuList",
      "setCurrentSubMenu",
      "setCurrentMovePlace",
    ]),
    onFirstMenuClick(e, item) {
      const list = JSON.parse(JSON.stringify(this.list)).map((f, index) => {
        if (f.id === item.id) {
          f.show = !f.show;
        } else {
          f.show = false;
        }
        return f;
      });
      this.setSubmenuList(list);
    },
    onMenuClick(e, item) {
      e.stopPropagation();
      this.menu = Array.from(document.querySelectorAll(".menu-second"));
      const index = this.menu.findIndex((f) => f.dataset.menuId === item.id);
      const distance = index * 58;
      const moveDom = document.querySelector(".top-move");
      moveDom.classList.remove(styles["init-top-move"]);
      this.setCurrentMovePlace({ place: distance });
      const correntId = item.id;
      const tempList = (function deep(list) {
        return list.map((item) => {
          const len = item.children.length;
          if (len > 0) {
            deep(item.children);
          } else {
            const currentStatus = correntId === item.id;
            item.current = currentStatus;
          }
          return item;
        });
      })(JSON.parse(JSON.stringify(this.list)));
      this.setSubmenuList(tempList);
      this.$router.push(item.href);
    },
    onMenuOver(e) {
      const el = e.target;
      el.classList.add(styles.active);
    },
    onMenuOut(e) {
      const el = e.target;
      el.classList.remove(styles.active);
    },
    initMovePlace(list) {
      const menu = list.some((item) => item.current);
      this.$nextTick(function() {
        const moveDom = document.querySelector(".top-move");
        moveDom.classList.add(styles["init-top-move"]);
        if (menu) {
          moveDom.classList.remove(styles["init-top-move"]);
          const distance = this.currentMovePlace.place;
          animate(moveDom, distance, "top");
        }
      });
    },
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        newVal.map((item) => {
          if (item.show) {
            const childrenMenu = item.children;
            this.$nextTick(function() {
              this.initMovePlace(childrenMenu);
            });
          }
        });
      },
      deep: true,
    },
  },
  render() {
    const { list, arrowStatus, fade } = this;
    const {
      indent,
      onMenuClick,
      onMenuOver,
      onMenuOut,
      onFirstMenuClick,
      onFirstMenuItemClick,
    } = this;
    const rnederArrow = (state) =>
      state ? (
        <img src={require("@/assets/images/menu_img/arrow_down.png")} />
      ) : (
        <img src={require("@/assets/images/menu_img/arrow_right.png")} />
      );
    // 新增：判断当前一级菜单是否激活
    const isActiveFirstMenu = (item) => {
      // 当前菜单展开且有子菜单
      return item.show && item.children && item.children.length > 0;
    };

    // 渲染唯一高亮条，切换一级菜单时判断是否显示
    const rnederSubMenu = (status, list) => {
      let highlightIndex = -1;
      if (status && Array.isArray(list) && list.length > 0 && this.currentSubMenu && this.currentSubMenu.id) {
        highlightIndex = list.findIndex(child => child.id === this.currentSubMenu.id);
      }
      return (
        <transition name="slide-vertical">
          {status ? (
            <ul class={styles["sub-list"]}>
              {/* 只有当前页面属于该一级菜单下的某个二级菜单时才显示高亮条 */}
              {highlightIndex !== -1 ? (
                <span
                  class={[styles["top-move"], "top-move"].join(" ")}
                  style={{ top: (highlightIndex * 58) + 'px' }}
                ></span>
              ) : null}
              {renderTrrNode(list)}
            </ul>
          ) : null}
        </transition>
      );
    };

    // 重写onSecondMenuClick，动画完成后再更新currentSubMenu和菜单数据
    const onSecondMenuClick = (e, item) => {
      e.stopPropagation();
      // 判断当前页面和被点击的二级菜单是否在同一个一级菜单下
      let found = false;
      let parentIndex = -1;
      let fromIndex = -1;
      let toIndex = -1;
      // 遍历所有一级菜单
      this.list.forEach((firstMenu, idx) => {
        if (Array.isArray(firstMenu.children)) {
          // 当前一级菜单下是否有当前高亮的二级菜单
          const curIdx = firstMenu.children.findIndex(child => child.id === (this.currentSubMenu && this.currentSubMenu.id));
          const tgtIdx = firstMenu.children.findIndex(child => child.id === item.id);
          if (curIdx !== -1 && tgtIdx !== -1) {
            found = true;
            parentIndex = idx;
            fromIndex = curIdx;
            toIndex = tgtIdx;
          }
        }
      });
      const moveDom = document.querySelector(".top-move");
      if (found && moveDom) {
        // 在同一个一级菜单下，滑动高亮条，动画完成后再更新数据
        animate(moveDom, toIndex * 58, "top").then(() => {
          this.setCurrentSubMenu(item);
          this.setCurrentMovePlace({ place: toIndex * 58 });
          // 设置current标记
          const correntId = item.id;
          const tempList = (function deep(list) {
            return list.map((item) => {
              const len = item.children.length;
              if (len > 0) {
                deep(item.children);
              } else {
                const currentStatus = correntId === item.id;
                item.current = currentStatus;
              }
              return item;
            });
          })(JSON.parse(JSON.stringify(this.list)));
          this.setSubmenuList(tempList);
          this.$router.push(item.href);
        });
      } else {
        // 不在同一个一级菜单下，直接高亮和跳转
        this.setCurrentSubMenu(item);
        this.menu = Array.from(document.querySelectorAll(".menu-second"));
        const index = this.menu.findIndex((f) => f.dataset.menuId === item.id);
        const distance = index * 58;
        if (moveDom) moveDom.style.top = distance + 'px';
        this.setCurrentMovePlace({ place: distance });
        // 设置current标记
        const correntId = item.id;
        const tempList = (function deep(list) {
          return list.map((item) => {
            const len = item.children.length;
            if (len > 0) {
              deep(item.children);
            } else {
              const currentStatus = correntId === item.id;
              item.current = currentStatus;
            }
            return item;
          });
        })(JSON.parse(JSON.stringify(this.list)));
        this.setSubmenuList(tempList);
        this.$router.push(item.href);
      }
    };

    // 修改renderTrrNode，二级菜单onClick用onSecondMenuClick
    const renderTrrNode = (data) => {
      return data.map((item) => {
        const children = item.children.length > 0;
        if (children) {
          return (
            <li
              data-id={item.id}
              onClick={(e) => onFirstMenuClick(e, item)}
              class={classnames(
                { [styles["menu-first-bg"]]: item.show },
                styles["menu-first"]
              )}
            >
              <span
                data-menu-id={item.id}
                onMouseover={onMenuOver}
                onMouseout={onMenuOut}
                class={classnames([styles["menu-top"], styles["menu-list"]])}
              >
                {item.title}
                <span class={styles.arrow}>{rnederArrow(item.show)}</span>
              </span>

              {rnederSubMenu(item.show, item.children)}
            </li>
          );
        } else {
          return (
            <li
              data-menu-id={item.id}
              onClick={(e) => onSecondMenuClick(e, item)}
              onMouseover={onMenuOver}
              onMouseout={onMenuOut}
              class={[
                styles["menu-list"],
                styles["menu-second"],
                "menu-list",
                "menu-second",
              ].join(" ")}
            >
              {item.title}
            </li>
          );
        }
      });
    };
    return (
      <ul class={styles["sub-menu"]}>
        {/*{rnederMoveSpan(list)}*/}
        {renderTrrNode(list)}
      </ul>
    );
  },
};
</script>
<style>
/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* slide-vertical for height展开/收缩动画 */
.slide-vertical-enter-active,
.slide-vertical-leave-active {
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s;
  overflow: hidden;
}
.slide-vertical-enter, .slide-vertical-leave-to {
  max-height: 0;
  opacity: 0;
}
.slide-vertical-enter-to, .slide-vertical-leave {
  max-height: 500px; /* 根据实际内容高度调整 */
  opacity: 1;
}
</style>
